import { z } from 'zod';

export const EXTEND_TYPE = {
  SESSION: 'session',
  EXAMINEE: 'examinee',
} as const;

const BaseExtendTimeFormSchema = z.object({
  extendType: z.enum([EXTEND_TYPE.SESSION, EXTEND_TYPE.EXAMINEE]),
  amount: z
    .number({ message: 'กรุณาระบุจำนวนเวลา' })
    .min(1, { message: 'กรุณาระบุจำนวนเวลา' })
    .max(60, { message: 'กรุณาระบุจำนวนเวลาไม่เกิน 60 นาที' }),
  remark: z.string().trim().min(1, { message: 'กรุณาระบุเหตุผลในการทดเวลา' }),
  examineeIds: z.array(z.string()).optional(),
});

function validateIndividualExtendType(
  data: z.infer<typeof BaseExtendTimeFormSchema>,
  ctx: z.RefinementCtx,
) {
  const { extendType, examineeIds } = data;

  if (extendType === EXTEND_TYPE.EXAMINEE && (!examineeIds || examineeIds.length === 0)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'กรุณาเลือกผู้เข้าสอบที่ต้องการทดเวลา',
      path: ['examineeIds'],
    });
  }
}

export const ExtendTimeFormSchema = BaseExtendTimeFormSchema.superRefine((data, ctx) =>
  validateIndividualExtendType(data, ctx),
);

export type ExtendTimeFormType = z.infer<typeof ExtendTimeFormSchema>;
